const returnToDomainNames = [
    'panasonic.aero',
    'panasonic.com',
    'nextcloud.aero',
    'amazonaws.com',
    'sandbox.my.site.com',
    'portalworks.io',
    'mascorp.com',
    'localhost',
];

export default returnToDomainNames;
